module.exports = __webpack_public_path__ + "static/testi-7-ba0d22b440ebcef546458ff5ee6659da.jpg";